// extracted by mini-css-extract-plugin
export default {"billing-data":"billing-data","billingData":"billing-data","tax-number":"tax-number","taxNumber":"tax-number"};